import { PropsWithChildren } from 'react'
import ReactQueryProvider from '../ReactQueryProvider'
import ThemeProvider from '../ThemeProvider'
import { Toaster } from 'sonner'
import { ErrorBoundary } from 'react-error-boundary'
import ErrorPage from '@/modules/error/components/ErrorPage'

export default function AppProvider({ children }: PropsWithChildren) {
	return (
		<ErrorBoundary fallbackRender={(props) => <ErrorPage {...props} />}>
			<ThemeProvider>
				<ReactQueryProvider>
					{children}
					<Toaster richColors position="top-center" />
				</ReactQueryProvider>
			</ThemeProvider>
		</ErrorBoundary>
	)
}
